import {
    COMMUNITY_NAME,
    DOCUMENT_TYPE,
  } from "./consts";
import { z } from "zod";
export const schema = z.object({
  [COMMUNITY_NAME]: z.string().min(2).max(100).optional(),
  [DOCUMENT_TYPE]: z.string().min(1, "Document Type is required"),
});

export type formValues = z.infer<typeof schema>;